
































import { Component, Prop, Vue } from "vue-property-decorator";

import ServiceMenuStatusIcon from "@/components/service-status/ServiceMenuStatusIcon.vue";
import ServiceMenuStatusIconWithLink from "@/components/service-status/ServiceMenuStatusIconWithLink.vue";
import {
  ServiceMenuStatus,
  ServiceMenuStatusIconType,
  ServiceMenuType,
} from "@/consts/const";
import { ServiceMenuInterface } from "@/interfaces/service-menu.interface";
import { StatusUtil } from "@/utils/status-util";

@Component({
  components: {
    ServiceMenuStatusIconWithLink,
    ServiceMenuStatusIcon,
  },
})
export default class ServiceMenuItem extends Vue {
  @Prop({ required: true }) private item!: ServiceMenuInterface;
  private ServiceMenuStatusIconType = ServiceMenuStatusIconType;

  private get hasWave(): boolean {
    return this.$device.isSp();
  }

  private get isPortalSite(): boolean {
    return this.item.type === ServiceMenuType.PortalSite;
  }

  private get statusList(): ServiceMenuStatus[] {
    if (this.isPortalSite) {
      return StatusUtil.getAllStatus(this.item.data);
    } else {
      return StatusUtil.getAllEventStatus(this.item.data);
    }
  }

  private get message(): string {
    return StatusUtil.getMessage(this.item.data);
  }

  private get textCssClass(): { [key: string]: boolean } {
    const status = StatusUtil.getMessageStatus(this.item.data);

    return {
      "status-text-color-error": [
        ServiceMenuStatus.Warning,
        ServiceMenuStatus.Error,
      ].includes(status),
      "status-text-color-other": [
        ServiceMenuStatus.Notification,
        ServiceMenuStatus.Maintenance,
      ].includes(status),
    };
  }

  private onClick(): void {
    this.$emit("click", this.item);
  }
}
